import React from "react";

import "./EntradaSite.css";

const REPETICOES_FAIXA = 12;

const BACKGROUND_IMAGE =
	"https://www.feevale.br/s/conteudo/647278ae-9e78-4758-a19a-b4eb92fe50df/01_Institucional27_Vestibular_Banner_1920x700px.png";

const FaixaConteudo = ({ texto, logoFaixaSrc }) => (
	<div className="entrada-site__faixa-grupo" aria-hidden="true">
		{Array.from({ length: REPETICOES_FAIXA }).map((_, index) => (
			<div className="entrada-site__faixa-item" key={index}>
				<span>{texto}</span>

				{logoFaixaSrc && (
					<img
						className="entrada-site__faixa-logo"
						src={logoFaixaSrc}
						alt=""
						loading="eager"
					/>
				)}
			</div>
		))}
	</div>
);

const EntradaSite = ({
	logoCentralSrc,
	logoCentralAlt = "Vestibular Feevale 2027",
	logoFaixaSrc = "https://www.feevale.br/s/conteudo/0513b825-4ecf-4c36-a425-acf325d7141b/logo_faixa.svg",
	textoFaixa = "VESTIBULAR 2027",
	nomePessoa = "",
	cursoPessoa = "",
	className = "",
}) => {
	return (
		<section className={`entrada-site ${className}`.trim()}>
			<div
				className="entrada-site__fundo"
				style={{ backgroundImage: `url(${BACKGROUND_IMAGE})` }}
				aria-hidden="true"
			/>

			<div className="entrada-site__conteudo">
				{(nomePessoa || cursoPessoa) && (
					<div className="entrada-site__infos-pessoa">
						{nomePessoa && (
							<strong className="entrada-site__nome-pessoa">
								{nomePessoa}
							</strong>
						)}

						{cursoPessoa && (
							<span className="entrada-site__curso-pessoa">
								{cursoPessoa}
							</span>
						)}
					</div>
				)}

				{logoCentralSrc && (
					<img
						className="entrada-site__logo-central"
						src={logoCentralSrc}
						alt={logoCentralAlt}
						loading="eager"
					/>
				)}
			</div>

			<div className="entrada-site__faixa entrada-site__faixa--inferior">
				<div className="entrada-site__faixa-track">
					<FaixaConteudo texto={textoFaixa} logoFaixaSrc={logoFaixaSrc} />
					<FaixaConteudo texto={textoFaixa} logoFaixaSrc={logoFaixaSrc} />
				</div>
			</div>
		</section>
	);
};

export default EntradaSite;
